import "../js/setup.js";
import React from "react";
import { createRoot } from "react-dom/client";
import LearningCatalogue from "domains/learningCatalogue";

setTimeout(() => {
  const root = createRoot(document.getElementById("react-main"));
  React.startTransition(() => {
    root.render(<LearningCatalogue public />);
  });
}, 0);
